import type { UUIDLocation } from '@/stores/store-interfaces';

const locationNames = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

/** Returns a copy of `items` ordered by name; the input array and its elements are left untouched. */
export function sortByName<T>(items: readonly T[], name: (item: T) => string): T[] {
    return [...items].sort((a, b) => locationNames.compare(name(a), name(b)));
}

/**
 * Orders every level of a location tree (regions, sites, buildings, ...) by name.
 * Applied in the stores right after a fetch so every consumer sees the same ordering
 * without re-sorting in components (ITDEVELOP-3093).
 */
export function sortLocationTree(items: readonly UUIDLocation[]): UUIDLocation[] {
    return sortByName(items, (item) => item.name).map((item) => ({
        ...item,
        children: item.children ? sortLocationTree(item.children) : item.children,
    }));
}
